const video = {
    pattern: {
        value: /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?[\w\?‌​=]*)?/,
        message: 'Wklej poprawny link'
    }
}

export default video